import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import Loader from "../Components/Loader/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import ParentComponent from "../Components/ParentComponent/ParentComponent";
import PrimaryHeader from "../Components/PrimaryHeader/PrimaryHeader";
import { toast } from "react-toastify";
import {
  ACTIVETAB,
  POST_LOGIN,
  afterPayment,
  getClientbyid,
} from "../Actions/actions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { BaseUrl } from "../BaseUrl/BaseUrl";

// App.jsx
const StripeForm = () => {
  const { loginData } = useSelector((state) => state.userReducer);
  const [clientSecret, setClientSecret] = useState("");
  const location = useLocation();
  const { amount, type, cycle, priceId } = location.state;
  useEffect(() => {
    // fetch clientSecret when app loads
    const fetchPaymentIntent = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");
      const response = await fetch(
        `${BaseUrl}/api/payments/create-payment-intent`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            amount: amount,
            subscriptionType: type,
            isBilledAnnually: cycle == "yearly" ? true : false,
          }),
        }
      );
      const result = await response.json();
      console.log(result, "res");
      setClientSecret(result.clientSecret);
    };

    fetchPaymentIntent();
  }, []);

  const stripePromise = loadStripe(
    "pk_test_51R4JIfPs9SlHAQ3iVqUqlXkxoyR3IS7Od5od3ngpwtHiWOhaIkDPR1sZ3UW7hmEgyyRceaMPIm5PLCMBmanvIqGt00Iqhg3ypS"
  );

  if (!clientSecret) {
    return (
      <div className="mt-20">
        <Loader />
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <CheckoutForm
        amount={amount}
        type={type}
        priceId={priceId}
        clientSecret={clientSecret}
      />
    </Elements>
  );
};
const CheckoutForm = (props) => {
  const { role, supportData, loader, loginData, subLoader, Privilages } =
    useSelector((state) => state.userReducer);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setloading] = useState(false);

  const handleSubmit = async (event) => {
    setloading(true);
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    await elements.submit();
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {},
      // payment_method: {
      //   billing_details: {
      //     name: "Customer Name",
      //     email: "customer@example.com",
      //   },

      // card: cardElement,
      // setup_future_usage: "off_session",

      clientSecret: props.clientSecret,
      redirect: "if_required",
    });

    if (error) {
      setErrorMessage(error.message);
    } else if (paymentIntent && paymentIntent.status === "succeeded") {
      dispatch(
        afterPayment(
          {
            priceId: props.priceId,
            paymentMethod: "Card",
            amount: props.amount,
            currency: "USD",
            description: props.type,
            paymentId: paymentIntent.id,
            paymentStatus: "paid",
            paymentDate: Date.now(),
            subscriptiontype: props.type,
          },
          loginData?.accessToken,
          () => {
            dispatch(
              getClientbyid(
                loginData?.accessToken,
                loginData?.clientData?.id,
                (result) => {
                  dispatch({
                    type: POST_LOGIN,
                    payload: { ...loginData, clientData: result.client },
                    role: role,
                    Privilages: Privilages,
                  });
                  navigate("/dashboard");
                  dispatch({
                    type: ACTIVETAB,
                    payload: "Dashboard",
                  });
                },
                () => {
                  setloading(false);
                }
              )
            );
          }
        )
      );
    }
  };

  return (
    <ParentComponent>
      <PrimaryHeader />
      <h2 className="text-md font-medium flex">
        Subscription Type: {props.type}
      </h2>
      <h2 className="text-md font-medium mb-10">
        Amount: AED {props.amount / 100}
      </h2>

      <form onSubmit={handleSubmit}>
        <PaymentElement />
        <div className="flex justify-end mt-10">
          {loading ? (
            <div className="mr-[125px]">
              <Loader />
            </div>
          ) : (
            <button
              className="w-[300px] max-w-sm py-2 text-sm bg-[#361D32] text-white rounded-md font-semibold"
              type="submit"
              disabled={!stripe || !elements}
            >
              Pay Now
            </button>
          )}
        </div>
        {/* {errorMessage && <div>{errorMessage}</div>} */}
      </form>
    </ParentComponent>
  );
};
export default StripeForm;
